import {Fill, Stroke, Style} from "ol/style";
import CircleStyle from "ol/style/Circle";
import VectorSource from "ol/source/Vector";
import {GeoJSON} from "ol/format";
import {Circle} from "ol/geom";
import {Feature} from "ol";
import VectorLayer from "ol/layer/Vector";
import {transform} from "ol/proj";
import {getDomainListItems} from "@/http/services/http-services-domainlist";
import {fromCircle} from "ol/geom/Polygon";

let vectorLayer

export function getDependentListLayerName() {
    return 'suspected'
}

export function loadGeomDependentList(coordinate) {

    let formID
    let column
    let key
    let name
    let attributeID
    let distance

    window.wizard.Items.map(item => {
        item.Items.map(subItem => {
            // If form has geom attribute
            if(item.Items.find(item => item.AttributeTypeID === 24)) {
                if(subItem.AttributeTypeID === 12) {
                    formID = item.ID
                    column = subItem.FormAttributeID
                    attributeID = subItem.AttributeID
                    key = 0
                    name = subItem.Name

                    console.log(subItem)

                    distance = subItem.LinkedLayer.distance
                }
            }
        })
    })

    const radiusDutch = distance / 1.9 // 3000 = 5 km
    const radius = distance

    if(!distance) {
        return
    }

    const coordinateDutch = transform(coordinate, 'EPSG:3857', 'EPSG:28992')

    const circle = new Circle(coordinateDutch, radiusDutch)
    const data = {}
    data.geometry = {}
    data.geometry.type = 'Point'
    data.geometry.coordinates = coordinateDutch
    data.column	= column
    data.columnName	= "tekst"
    data.geometryCheck	= "true"

    data.columns = [
        {
            data: 'Geom_rd',
        },
        {
            data: 'Omschrijving'
        },
        {
            data: 'OD_id'
        }
    ]

    data.querytype = 'WITHIN'
    data.geometry = {
        column: 'Geom_rd',
        coord: fromCircle(circle.clone()).getFlatCoordinates()
    }

    getDomainListItems(formID, data).then(result => {
        return result.json()
    }).then(result => {

        window.domainListItems[key] = []

        result.features.map(feature => {
            window.domainListItems[key].push({
                Value: feature.properties.value,
                Name: feature.properties.name,
                Image: ''
            })
        })

        if(vectorLayer) {
            window.map.removeLayer(vectorLayer)
        }

        const styleFunction = function (feature) {

            switch (feature.getGeometry().getType()) {
                case 'Point':
                    return new Style({
                        image: new CircleStyle({
                            radius: 5,
                            fill: new Fill({
                                color: 'rgba(0, 87, 129, 0.8)',
                            }),
                            stroke: new Stroke({
                                color: 'rgba(0, 87, 129, 1)',
                                width: 1
                            }),
                        }),
                    })
                case 'Circle':
                    return new Style({
                        stroke: new Stroke({
                            color: 'rgba(255,0,0,0.3)',
                            width: 2,
                        }),
                        fill: new Fill({
                            color: 'rgba(255,0,0,0.1)',
                        }),
                    })
            }
        }

        const vectorSource = new VectorSource()

        let circle = new Circle(coordinate, radius)

        vectorLayer = new VectorLayer({
            name: getDependentListLayerName(),
            source: vectorSource,
            style: styleFunction,
        })

        window.map.addLayer(vectorLayer)
        vectorSource.addFeature( new Feature(circle));
        vectorSource.addFeatures(
            new GeoJSON({
                dataProjection: 'EPSG:28992',
                featureProjection: 'EPSG:3857'
            }).readFeatures(result)
        );


        const element = document.querySelector('form-domain-list-single[data-attribute-id="' + attributeID + '"]')
        if(element) {

            let isRequired = ''
            // if(wizardItem.IsRequired) {
            //     isRequired = '*'
            // }

            element.innerHTML =
                `<form-domain-list-single data-is-required="${isRequired}" data-key="${key}" data-name="${name}" data-attribute-id="${attributeID}"></form-domain-list-single>`
        }
    })
}
